export default {"src":"/_next/static/media/iRacing-Icon-Color-White.242fcdc2.svg","height":372,"width":486,"blurWidth":0,"blurHeight":0};